<template>
  <div :id="component_id" class="">
    <div v-show="show_options" class="options-container px-2 py-2" :class="{'z-20':show_options}">
      <div class="self-stretch px-4 py-2 bg-transparent rounded-md flex flex-col justify-center gap-0.5">
        <div class="self-stretch inline-flex justify-start items-center gap-2">
          <messenger-avatar key="option_menu_avatar" class="mr-1 select-none cursor-default" :name="user_display_name" :size="32" :bg-color="$FUSfusionAvatarColorsHex[0]" @click="handleAvatarClick" />
          <div class="flex-1 inline-flex flex-col justify-start gap-0.5">
            <div class="self-stretch justify-start text-text-default text-sm leading-4 tracking-tight">{{ user_display_name }}</div>
            <div class="self-stretch justify-start"><span class="text-text-subtle text-xs leading-4 tracking-tight">@</span><span class="text-text-subtle text-xs leading-4 tracking-tight">{{ user_display_name }} </span></div>
          </div>
        </div>
      </div>
      <div v-if="false" class="self-stretch h-3 bg-transparent rounded-md flex flex-col justify-center gap-0.5">
        <div class="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-border-separator"></div>
      </div>
      <div v-if="false" class="self-stretch h-8 px-4 bg-transparent rounded-md flex flex-col justify-center gap-0.5">
        <div class="self-stretch inline-flex justify-start items-center gap-4 opacity-50">
          <div class="w-4 h-4 flex justify-center items-center gap-2.5">
            <img :src="memories_icon" :alt="options_headers['MEMORIES']" class="w-full h-full object-cover" />
          </div>
          <div class="flex-1 justify-center text-text-default text-sm leading-4 tracking-tight">{{ options_headers['MEMORIES'] }}</div>
        </div>
      </div>
      <div class="self-stretch h-3 bg-transparent rounded-md flex flex-col justify-center gap-0.5">
        <div class="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-border-separator"></div>
      </div>
      <!-- Scheduled tasks ship dark. This row appears only once the API has said the feature is available
           for this caller's store — an answer that already folds in the FUSION_SCHEDULED_TASKS deployment
           switch AND the per-rooftop beta flag, so the environment variable stays the single control and
           this needs no edit when it is eventually turned on. Hidden while the answer is pending, failed
           or malformed: a menu entry that appears and then vanishes is worse than one that appears late. -->
      <div v-if="scheduled_enabled" class="self-stretch h-8 px-4 bg-transparent rounded-md flex flex-col justify-center gap-0.5">
        <div class="self-stretch inline-flex justify-start items-center gap-4" :class="settings_loading ? 'opacity-50 cursor-default' : 'cursor-pointer'" @click="!settings_loading && openOptions('SCHEDULES')">
          <div class="w-4 h-4 flex justify-center items-center gap-2.5">
            <img :src="schedules_icon" :alt="options_headers['SCHEDULES']" class="w-full h-full object-cover" />
          </div>
          <div class="flex-1 justify-center text-text-default text-sm leading-4 tracking-tight">{{ options_headers['SCHEDULES'] }}</div>
        </div>
      </div>
      <div class="self-stretch h-8 px-4 bg-transparent rounded-md flex flex-col justify-center gap-0.5">
        <div class="self-stretch inline-flex justify-start items-center gap-4" :class="settings_loading ? 'opacity-50 cursor-default' : 'cursor-pointer'" @click="!settings_loading && openOptions('GENERAL-SETTINGS')">
          <div class="w-4 h-4 flex justify-center items-center gap-2.5">
            <img :src="settings_icon" :alt="options_headers['GENERAL-SETTINGS']" class="w-full h-full object-cover" />
          </div>
          <div class="flex-1 justify-center text-text-default text-sm leading-4 tracking-tight">{{ options_headers['GENERAL-SETTINGS'] }}</div>
        </div>
      </div>
      <div class="self-stretch h-8 px-4 bg-transparent rounded-md flex flex-col justify-center gap-0.5">
        <div class="self-stretch inline-flex justify-start items-center gap-4" :class="settings_loading ? 'opacity-50 cursor-default' : 'cursor-pointer'" @click="!settings_loading && openOptions('REY-PREFERENCES')">
          <div class="w-4 h-4 flex justify-center items-center gap-2.5">
            <img :src="rey_preferences_icon" :alt="options_headers['REY-PREFERENCES']" class="w-full h-full object-cover" />
          </div>
          <div class="flex-1 justify-center text-text-default text-sm leading-4 tracking-tight">{{ options_headers['REY-PREFERENCES'] }}</div>
        </div>
      </div>
      <div v-if="false" class="self-stretch h-8 px-4 bg-transparent rounded-md flex flex-col justify-center gap-0.5">
        <div class="self-stretch inline-flex justify-start items-center gap-4" :class="settings_loading ? 'opacity-50 cursor-default' : 'cursor-pointer'" @click="!settings_loading && openOptions('NOTIFICATION-PREFERENCES')">
          <div class="w-4 h-4 flex justify-center items-center gap-2.5">
            <img :src="notification_preferences_icon" :alt="options_headers['NOTIFICATION-PREFERENCES']" class="w-full h-full object-cover" />
          </div>
          <div class="flex-1 justify-center text-text-default text-sm leading-4 tracking-tight">{{ options_headers['NOTIFICATION-PREFERENCES'] }}</div>
        </div>
      </div>
      <div v-if="false" class="self-stretch h-8 px-4 bg-transparent rounded-md flex flex-col justify-center gap-0.5">
        <div class="self-stretch inline-flex justify-start items-center gap-4 opacity-50">
          <div class="w-4 h-4 flex justify-center items-center gap-2.5">
            <img :src="help_icon" :alt="options_headers['HELP']" class="w-full h-full object-cover" />
          </div>
          <div class="flex-1 justify-center text-text-default text-sm leading-4 tracking-tight">{{ options_headers['HELP'] }}</div>
        </div>
      </div>
      <div v-if="false" class="self-stretch h-3 bg-transparent rounded-md flex flex-col justify-center gap-0.5">
        <div class="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-border-separator"></div>
      </div>
      <div v-if="false" class="self-stretch h-8 px-4 bg-transparent rounded-md flex flex-col justify-center gap-0.5">
        <div class="self-stretch inline-flex justify-start items-center gap-4 opacity-50">
          <div class="w-4 h-4 flex justify-center items-center gap-2.5">
            <img :src="log_out_icon" :alt="options_headers['LOG-OUT']" class="w-full h-full object-cover" />
          </div>
          <div class="flex-1 justify-center text-text-default text-sm leading-4 tracking-tight">{{ options_headers['LOG-OUT'] }}</div>
        </div>
      </div>
      <div v-if="settings_loading" class="options-loading-overlay">
        <div class="fusion-loader loader-md"></div>
      </div>
    </div>
    
    <dialog-modal :isOpen="Boolean(dialog_mode)" variant="2" :showCloseButton="true" :show-footer="has_unsaved_changes && !is_read_only" :processing="is_saving" backdropType="clear" :title="dialog_title" @close="closeDialog" @save="handleDialogSave">
      <!-- Main Content Slot -->
      <general-settings v-if="dialog_mode==='GENERAL-SETTINGS'" ref="settingsComponent" key="general_settings" :settings="user_settings" @save="handleSettingsSave" @cancel="closeDialog" @changes="handleChangesUpdate" />
      <rey-preferences v-else-if="dialog_mode==='REY-PREFERENCES'" ref="settingsComponent" key="rey_preferences" :settings="user_settings" @save="handleSettingsSave" @cancel="closeDialog" @changes="handleChangesUpdate" />
      <notifications-preferences v-else-if="dialog_mode==='NOTIFICATION-PREFERENCES'" ref="settingsComponent" key="notifications_preferences" :settings="user_settings" @save="handleSettingsSave" @cancel="closeDialog" @changes="handleChangesUpdate" />
      <scheduled-management v-else-if="dialog_mode==='SCHEDULES'" :key="`scheduled_${scheduled_initial_view}`" :initial-view="scheduled_initial_view" @close="closeDialog" />
    </dialog-modal>
  </div>
</template>
<style scoped>
.options-container {
  position: absolute;
  width: 280px;
  bottom: 60px;
  right: 8px;
  background-color: var(--background-layer-01);
  box-shadow: 0px 4px 24px rgba(16, 20, 29, 0.06), 0px 2px 6px rgba(16, 20, 29, 0.06);
  border-radius: 6px;
  border: 1px solid var(--border-default);
  box-sizing: border-box;
}
.options-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}
.options-loading-overlay::before {
  content: '';
  position: absolute;
  inset: 0;
  background-color: var(--background-layer-01);
  opacity: 0.7;
  border-radius: 6px;
}
.options-loading-overlay .fusion-loader {
  position: relative;
  z-index: 1;
}
</style>
<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@store/main';
import MessengerAvatar from '@components/Messaging/MessengerAvatar.vue';
import DialogModal from '@components/UI/DialogModal.vue';
import GeneralSettings from '@components/Settings/GeneralSettings.vue';
import ReyPreferences from "@components/Settings/ReyPreferences.vue";
import NotificationsPreferences from "@components/Settings/NotificationsPreferences.vue";
import ScheduledManagement from '@components/Scheduled/ScheduledManagement.vue';
import HelpIcon from '@images/help_icon.svg';
import LogOutIcon from '@images/log_out_icon.svg';
import MemoriesIcon from '@images/memories_icon.svg';
import NotificationPreferencesIcon from '@images/notification_preferences_icon.svg';
import ReyPreferencesIcon from '@images/rey_preferences_icon.svg';
import SchedulesIcon from '@images/schedules_icon.svg';
import SettingsIcon from '@images/settings_icon.svg';

export default {
  props: {
    triggerShowOptions: {
      type: Number,
      required: false,
      default: 0
    },
    setConfiguration: {
      type: Object,
      required: false,
      default: null
    },
  },
  components: {
    'messenger-avatar': MessengerAvatar,
    'dialog-modal': DialogModal,
    'general-settings': GeneralSettings,
    'rey-preferences': ReyPreferences,
    'notifications-preferences': NotificationsPreferences,
    'scheduled-management': ScheduledManagement,
  },
  created() {
    // Fetch settings on create if not already in store
    if(!this.user_settings) {
      this.fetchSettings();
    }
    this.getScheduledAvailability();
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    window.event_bus.$on('close-options-menu', this.handleCloseOptionsMenu);
    // The Scheduled tasks thread's "See all results". It lives here because the results inbox is
    // inside this menu's dialog — the thread has no way to open it otherwise, and with the thread
    // capped at its twenty most recent messages this is the only route to the rest.
    window.event_bus.$on('SCHEDULED-OPEN-RESULTS', this.openScheduledResults);
    // The way back out: a result's "Open" in that same inbox. Handled here because this menu owns the
    // dialog that has to close first, and it is the one per page — the toolbar hides FusionBody's copy.
    window.event_bus.$on('SCHEDULED-OPEN-RESULT-THREAD', this.openResultThread);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    window.event_bus.$off('close-options-menu', this.handleCloseOptionsMenu);
    window.event_bus.$off('SCHEDULED-OPEN-RESULTS', this.openScheduledResults);
    window.event_bus.$off('SCHEDULED-OPEN-RESULT-THREAD', this.openResultThread);
  },
  data() {
    return {
      help_icon: HelpIcon,
      log_out_icon: LogOutIcon,
      memories_icon: MemoriesIcon,
      notification_preferences_icon: NotificationPreferencesIcon,
      rey_preferences_icon: ReyPreferencesIcon,
      schedules_icon: SchedulesIcon,
      settings_icon: SettingsIcon,
      show_options: false,
      settings_loading: false,
      availability_processing: false,
      send_message: '',
      dialog_mode: null,
      // Which screen the Schedules dialog opens on. Cleared when the dialog closes so the menu's own
      // Schedules row always lands on the task list — only the thread's results link asks otherwise.
      scheduled_initial_view: '',
      has_unsaved_changes: false,
      is_saving: false,
    }
  },
  computed: {
    ...mapStores(useMainStore),
    user_access_info() {
      return this.mainStore.user_access_info;
    },
    is_read_only() {
      return this.mainStore.is_read_only;
    },
    component_key() {
      return this.$attrs.key?this.$attrs.key:('options_menu_'+Date.now());
    },
    component_id() {
      return this.component_key+'_container';
    },
    // Menu/dialog headers — computed (not data) so they follow the UI language.
    options_headers() {
      return {
        'MEMORIES': this.$t('settings.menu.memories'),
        'SCHEDULES': this.$t('settings.menu.schedules'),
        'GENERAL-SETTINGS': this.$t('settings.menu.generalSettings'),
        'REY-PREFERENCES': this.$t('settings.menu.reyPreferences'),
        'NOTIFICATION-PREFERENCES': this.$t('settings.menu.notificationPreferences'),
        'HELP': this.$t('settings.menu.help'),
        'LOG-OUT': this.$t('settings.menu.logOut'),
      };
    },
    user_display_name() {
      return this.user_access_info?.displayName || this.$t('common.unknownName');
    },
    user_guid() {
      return this.user_access_info?.userId || null;
    },
    user_settings() {
      return this.mainStore.user_settings;
    },
    current_cif() {
      return this.mainStore.current_cif;
    },
    scheduled_availability: {
      get() { return this.mainStore.scheduled_availability; },
      set(value) { this.mainStore.scheduled_availability = value; }
    },
    scheduled_availability_generation() {
      return this.mainStore.scheduled_availability_generation;
    },
    // Only ever true once the server has affirmatively said so. Deliberately the OPPOSITE polarity to
    // ScheduledManagement.beta_closed, which only asserts closure when told: that panel is already open,
    // so a flash of "unavailable" would be wrong there. Here the question is whether to offer a way in at
    // all, and pending/failed/unrecognised must all read as "do not offer it".
    scheduled_enabled() {
      return this.scheduled_availability?.enabled === true;
    },
    dialog_title() {
      if(this.options_headers.hasOwnProperty(this.dialog_mode))
        return this.options_headers[this.dialog_mode];
      
      return null;
    },
  },
  methods: {
    handleAvatarClick() {
      window.event_bus.$emit('UNAUTHORIZED-CLICK');
    },
    handleClickOutside(event) {
      if (this.show_options) {
        const container = this.$el.querySelector('.options-container');
        // Check if the click was on the trigger button (ignore those clicks)
        const triggerButton = document.querySelector('.options-menu-trigger');
        const isClickOnTrigger = triggerButton && (triggerButton === event.target || triggerButton.contains(event.target));
        
        // Check if the click was outside the menu and not on the trigger
        if (container && !container.contains(event.target) && !isClickOnTrigger) {
          this.handleCloseOptionsMenu();
        }
      }
    },
    handleCloseOptionsMenu() {
      this.show_options = false;
      this.$emit('updateShowOptions', false);
    },
    openOptions(option) {
      this.show_options = false;
      this.dialog_mode = option;
    },
    handleDialogSave() {
      // Call the child component's save method via ref
      if (this.$refs.settingsComponent && typeof this.$refs.settingsComponent.save === 'function') {
        this.$refs.settingsComponent.save();
      }
    },
    handleChangesUpdate(hasChanges) {
      this.has_unsaved_changes = hasChanges;
    },
    closeDialog() {
      this.scheduled_initial_view = '';
      this.dialog_mode = null;
      this.has_unsaved_changes = false;
    },
    setLanguage(language) {
      this.mainStore.setLanguage(language);
    },
    /**
     * Opens the Schedules dialog on the results list, for the thread's "See all results".
     *
     * Sets the view BEFORE the dialog mode: scheduled-management reads initialView once in data(),
     * so the order decides whether it opens on results or on the task list. The key includes the
     * view so re-opening actually remounts rather than reusing a component already sitting on the
     * other screen.
     */
    openScheduledResults() {
      this.scheduled_initial_view = 'inbox';
      this.openOptions('SCHEDULES');
    },
    /**
     * A result's "Open" in the Schedules inbox: close the dialog and hand the conversation up.
     *
     * The parent decides how to get there, because only it knows where the Rey panel is. FusionToolbar
     * switches to its Spark tab first; a FusionBody that IS the Spark panel opens it in place; any other
     * FusionBody — an Internal Messages or Client Record blade in the WingCommander extension — has no
     * Rey panel at all and asks the host to open its Rey blade on it.
     */
    openResultThread(threadId) {
      if (!threadId) return;
      this.closeDialog();
      this.$emit('openReyConversation', threadId);
    },
    invalidateScheduledAvailability() {
      this.mainStore.InvalidateScheduledAvailability();
    },
    // Whether the scheduled-tasks beta is open to this caller, which is what decides if the Schedules row
    // is offered at all. Shares the store field with ScheduledManagement on purpose: two surfaces
    // disagreeing about the same store is the defect the availability endpoint was added to remove.
    getScheduledAvailability() {
      if (this.availability_processing) return;
      const self = this;
      // The generation this reply belongs to. Anything that makes the answer stale — a rooftop switch
      // (watched below) or a user switch (ClearUserScopedState) — bumps it, so a reply that outlived its
      // scope is discarded instead of written. Without that, a request already in flight lands after the
      // clear and restores the stale verdict; and because the re-ask guard skips a truthy answer, that
      // one late reply pins it for the session.
      //
      // A counter rather than a comparison of ids, because availability depends on BOTH the caller and
      // the rooftop: a same-device user switch usually leaves the rooftop unchanged, so comparing stores
      // would not notice it. Nor is the dealerId the reply echoes usable — the server resolves an absent
      // or unrecognised rooftop to the caller's first association, so on a host with no CIF context the
      // echo never matches what was sent and every reply would be thrown away.
      const generation = this.scheduled_availability_generation;
      this.availability_processing = true;
      this.mainStore.GetScheduledAvailability(this.current_cif).then((response) => {
        // Superseded: the invalidation already cleared availability_processing, and a newer request may
        // now own it — so this reply must touch neither that flag nor the answer.
        if (generation !== self.scheduled_availability_generation) return;
        self.availability_processing = false;
        // Only a well-formed answer counts. Anything else leaves availability unknown rather than
        // guessing an answer out of a shape we did not recognise.
        self.scheduled_availability = response && typeof response.enabled === 'boolean' ? response : null;
      }, () => {
        if (generation !== self.scheduled_availability_generation) return;
        self.availability_processing = false;
        self.scheduled_availability = null;
      });
    },
    async fetchSettings() {
      if(!this.user_guid) return;
      this.settings_loading = true;
      try {
        const getSettingsDTO = `tenantId=default-tenant&userId=${this.user_guid}`;
        const response = await this.mainStore.GetSettings(getSettingsDTO);
        if(response && response.flat) {
          this.mainStore.user_settings = response;
          // Apply saved theme from user profile
          const savedTheme = response.flat['Ux.Theme'];
          if (savedTheme) this.mainStore.setTheme(savedTheme);
          // Apply saved UI language from user profile
          const savedLanguage = response.flat['Ux.Language'];
          if (savedLanguage) this.setLanguage(savedLanguage);
        }
      }
      catch (error) {
        console.error('Error fetching settings:', error);
      }
      finally {
        this.settings_loading = false;
      }
    },
    async handleSettingsSave(patch) {
      if(!this.user_guid || !patch) {
        this.closeDialog();
        return;
      }
      
      this.is_saving = true;
      
      try {
        const saveSettingsDTO = {
          scope: {
            tenantId: 'default-tenant',
            dealerId: null,
            roleCode: null,
            userId: this.user_guid
          },
          surface: null,
          patch: patch
        };
        const response = await this.mainStore.SaveSettings(saveSettingsDTO);
        // Use response to update cache instead of re-fetching
        if (response && response.flat) {
          this.mainStore.user_settings = response;
        }
        // Apply theme change immediately if it was part of the patch
        if (patch['Ux.Theme']) {
          this.mainStore.setTheme(patch['Ux.Theme']);
        }
        // Apply language change immediately if it was part of the patch — every $t() binding
        // re-renders, so the UI switches without a reload.
        if (patch['Ux.Language']) {
          this.setLanguage(patch['Ux.Language']);
        }
        // A personality change is otherwise invisible until the user's next question, so have Rey
        // acknowledge it in her new voice. MessengerWindow owns the message list as component-local
        // state, so the bus is the only way to reach it from here.
        //
        // The key is only present when the value actually changed — ReyPreferences.settings_patch
        // diffs against original_values — so a save that only touched the display name stays silent.
        if (patch['Ux.Personality']) {
          window.event_bus.$emit('REY-PERSONALITY-CHANGED', { personality: patch['Ux.Personality'] });
        }
        // Close dialog after successful save
        this.closeDialog();
      } catch (error) {
        console.error('Error saving settings:', error);
        // Still close on error, but could show error message instead
        this.closeDialog();
      } finally {
        this.is_saving = false;
      }
    },
  },
  watch: {
    // Availability is answered per rooftop, so a switch makes the held answer about someone else's store.
    // Dropped rather than re-fetched: nothing reads it until the menu is opened, and the open handler
    // below already asks whenever the answer is unknown — so this costs no request on a rooftop switch
    // the user may never follow with a menu click. Until then the row stays hidden, which is the right
    // direction to be wrong in: the write paths would refuse anyway.
    current_cif() {
      this.invalidateScheduledAvailability();
    },
    // Every invalidation, wherever it came from, supersedes the request in flight — its reply will be
    // discarded on arrival, so the component must stop treating it as the outstanding one or the guard
    // above would refuse to ask again and the row would never resolve. This is also what lets a menu
    // opened during that window issue a fresh request rather than sit behind a reply that cannot land.
    scheduled_availability_generation() {
      this.availability_processing = false;
    },
    triggerShowOptions(newValue, oldValue) {
      if(newValue > 0) {
        // Emit event to close any open overlays (modals, popups, tooltips, dropdowns, etc.)
        window.event_bus.$emit('CLOSE-OVERLAYS');
        this.show_options = !Boolean(this.show_options);
        this.$emit('updateShowOptions', this.show_options);
        if (this.show_options) {
          this.fetchSettings();
          // Retry only while the answer is still unknown. The component is created once per session, so
          // a single blocked or failed lookup at start-up would otherwise hide the row until a reload —
          // but re-asking on every open would spend a request per menu click to re-learn a settled answer.
          if (!this.scheduled_availability) {
            this.getScheduledAvailability();
          }
        }
      }
    },
  }
}
</script>
